module.exports = __webpack_public_path__ + "img/red_open.02813d80.png";